import { render, staticRenderFns } from "./DummySearchTriggerContainer.vue?vue&type=template&id=9a8fed88"
import script from "./DummySearchTriggerContainer.vue?vue&type=script&lang=js"
export * from "./DummySearchTriggerContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports